import React from 'react';
import ReactDOMServer from 'react-dom/server';
import parse from 'html-react-parser';

// Types.
import { ManageContractsRadioCheckboxProps } from '../../../types/contract';

export const ManageContractsRadio: React.FunctionComponent<ManageContractsRadioCheckboxProps> = (props: ManageContractsRadioCheckboxProps) => {
  const { radioID, radioName, extraClass, onChangeFunc, checkedComparison, multipleLines, label } = props;

  let printLabel;
  if (typeof label === 'string') {
    printLabel = parse(label);
  } else if (label) {
    printLabel = parse(ReactDOMServer.renderToStaticMarkup(label));
  }

  return (
    <div className={`form-item radio ${multipleLines ? 'form-item-multiple-lines' : ''} ${extraClass ? extraClass : ''}`}>
      <input type="radio" id={radioID} name={radioName} onChange={onChangeFunc} checked={checkedComparison} />
      <div className="form-item-input"></div>
      <label htmlFor={radioID}>{printLabel}</label>
    </div>
  );
};

export const ManageContractsCheckbox: React.FunctionComponent<ManageContractsRadioCheckboxProps> = (props: ManageContractsRadioCheckboxProps) => {
  const { radioID, radioName, extraClass, onChangeFunc, checkedComparison, multipleLines, label, extraHtml } = props;

  let printLabel;
  if (typeof label === 'string') {
    printLabel = parse(label);
  } else if (label) {
    printLabel = parse(ReactDOMServer.renderToStaticMarkup(label));
  }

  return (
    <div className={`form-item checkbox ${multipleLines ? 'form-item-multiple-lines' : ''} ${extraClass ? extraClass : ''}`}>
      <input type="checkbox" id={radioID} name={radioName} onChange={onChangeFunc} checked={checkedComparison} />
      <div className="form-item-input"></div>
      <label htmlFor={radioID}>{printLabel}</label>
      {extraHtml && extraHtml}
    </div>
  );
};

export default ManageContractsRadio;
